import { getValidationCode } from '@/api/user/user';

export default {
  data() {
    return {
      validationCodeUrl: '',
    };
  },
  mounted() {
    this.getValidationCode();
  },
  methods: {
    async getValidationCode() {
      const res = await getValidationCode();
      if (res) {
        this.validationCodeUrl = res;
      }
    },
  },
};
